import { logFetchError } from "src/auth/utils/log";
import { buildUrl } from "src/utils/url";
import { urlConfig } from "src/utils/urlConfig";
import type {
  KoddiDestinationBrandingRequest,
  KoddiDestinationBrandingResponse,
  SendKoddiClick,
  SendKoddiImpression,
  UrlData,
} from "./KoddiResponse";

export async function getKoddiDestinationBranding({
  apiConfig,
  destination,
  language,
  currency,
}: KoddiDestinationBrandingRequest): Promise<KoddiDestinationBrandingResponse | null> {
  const url = buildUrl(
    `/api/1.6/placements/destination-branding/${destination}`,
    urlConfig.apiHost,
    {
      key: import.meta.env.VITE_API_KEY,
      language,
      currency,
    },
  );

  const response = await fetch(url, {
    method: "POST",
  });

  if (!response.ok) {
    const err = `Error fetching Koddi destination branding data: ${response.status} ${response.statusText}`;
    logFetchError(err);
    throw new Error(err);
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
}

export async function sendKoddiImpression({
  impressionUrl,
  urlData,
}: SendKoddiImpression): Promise<Response> {
  const url = getKoddiUrl(impressionUrl, urlData);

  try {
    return await fetch(url, {
      method: "GET",
      headers: { accept: "application/json" },
    });
  } catch (err) {
    logFetchError(err);
    throw err;
  }
}

export async function sendKoddiClick({
  clickTrackingUrl,
  urlData,
}: SendKoddiClick): Promise<Response> {
  const url = getKoddiUrl(clickTrackingUrl, urlData);

  try {
    return await fetch(url, {
      method: "GET",
      headers: { accept: "application/json" },
    });
  } catch (err) {
    logFetchError(err);
    throw err;
  }
}

function getKoddiUrl(url: string, urlData: UrlData) {
  const ts = new Date().toISOString();
  return url
    .replace("{trackingData}", urlData.trackingData)
    .replace("{rank}", urlData.rank)
    .replace("{ts}", ts);
}
